<template>
  <div class="electricity">
    <div class="electricity-top">
      <span class="top-left">用电监控</span>
      <div class="top-right">
        <el-select
          v-model="provincesName"
          clearable
          placeholder="请选择"
          @change="getCity(provincesName)"
        >
          <el-option
            v-for="item in provincesList"
            :key="item.province"
            :label="item.province"
            :value="item.province"
          ></el-option>
        </el-select>
        <el-select v-model="cityName" clearable placeholder="请选择" @change="cityChange(cityName)">
          <el-option
            v-for="item in cityList"
            :key="item.city"
            :label="item.city"
            :value="item.city"
          ></el-option>
        </el-select>
        <el-select
          v-model="stationName"
          clearable
          placeholder="请选择场站"
          @change="stationChange(stationName)"
        >
          <el-option
            v-for="item in stationList"
            :key="item.station_id"
            :label="item.station_name"
            :value="item.station_id"
          ></el-option>
        </el-select>
      </div>
    </div>
    <div class="electricity-bottom">
      <!-- 功率阈值模块 -->
      <div class="power-threshold" id="power-threshold" :style="{height:height1+'px'}">
        <div class="threshold-title">功率阈值</div>
        <div class="threshold-content clearfix">
          <div class="box clearfix">
            <div class="content-input">
              <span>变压器峰值(PQ)：</span>
              <el-input
                v-model="station_peak"
                :disabled="thresholdPrivilege==1"
                clearable
                placeholder
              ></el-input>
            </div>
            <div class="content-input">
              <span>负荷控制范围：</span>
              <el-input
                v-model="station_threshold"
                :disabled="thresholdPrivilege==1"
                clearable
                placeholder
              ></el-input>
            </div>
          </div>
          <div class="box">
            <div class="content-input">
              <span>&nbsp;场站峰值(PQC)：</span>
              <el-input
                v-model="charger_peak"
                :disabled="thresholdPrivilege==1"
                clearable
                placeholder
              ></el-input>
            </div>
            <div class="content-input">
              <span>负荷控制范围：</span>
              <el-input
                v-model="charger_threshold"
                :disabled="thresholdPrivilege==1"
                clearable
                placeholder
              ></el-input>
            </div>
          </div>
          <div class="save-btn">
            <el-button
              @click="saveStationDetail()"
              :class="[thresholdPrivilege==1?'active':'']"
              :disabled="thresholdPrivilege==1"
            >保存</el-button>
          </div>
        </div>
        <div class="line-line"></div>
        <div class="soc clearfix">
          <div class="content-input">
            <span>满充SOC：</span>
            <el-select v-model="soc" placeholder="请选择SOC">
              <el-option
                v-for="item in socList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
          <div class="save-btn">
            <el-button @click="socClick()">保存</el-button>
          </div>
        </div>
      </div>

      <div class="power-ratio" id="power-ratio" :style="{height:height1+'px'}">
        <div class="ratio-title">桩功率占比</div>
        <div id="echart" style="width:100%;"></div>
      </div>
      <div class="watt-hour-meter" id="watt-hour-meter" :style="{height:height1+'px'}">
        <div class="meter-title">电表电量</div>
        <div class="right-btn">
          <span :class="[active==1?'active':'']" @click="dateClick(1)">小时</span>
          <span>/</span>
          <span :class="[active==2?'active':'']" @click="dateClick(2)">日</span>
          <span>/</span>
          <span :class="[active==3?'active':'']" @click="dateClick(3)">月</span>
        </div>
        <div id="meter-echart" style="width:100%;height:87%"></div>
      </div>
      <div
        class="total-power-station clearfix"
        id="total-power-station"
        :style="{height:height1+'px'}"
      >
        <div class="station-title">场站总功率(KW)</div>
        <div id="station-echart" style="width:100%;height:100%"></div>
      </div>
      <div class="power-charging-pile" id="power-charging-pile" :style="{height:height1+'px'}">
        <div class="pile-title">充电桩功率(KW)</div>
        <div class="pile-select">
          <el-select
            v-model="chargersName"
            clearable
            placeholder="请选择"
            @change="stationChargersChange(chargersName)"
          >
            <el-option
              v-for="item in chargersList"
              :key="item.charger_id"
              :label="item.charger_name"
              :value="item.charger_id"
            ></el-option>
          </el-select>
        </div>
        <div id="pile-echart" style="width:100%;height:90%"></div>
      </div>
    </div>
  </div>
</template>

<script>
import echarts from "echarts";
import { constants } from "fs";
export default {
  data() {
    return {
      height1: "",
      height2: "",
      height3: "",
      height4: "",
      height5: "",
      width1: "",
      width2: "",
      width3: "",
      width4: "",
      width5: "",
      provincesName: "",
      provincesList: [],
      cityName: "",
      stationName: "",
      stationId: "",
      cityList: [],
      stationList: [],
      value: "",
      options: [],
      active: 1,
      metersData: {},
      stationPowers: [],
      chargerPower: [],
      powerThreshold: "",
      powerRateList: [], //桩功率占比
      chargersList: [], //充电桩功率下拉
      chargersName: "",
      chargersId: "",
      station_peak: "", //	场站负荷峰值
      station_threshold: "", //	场站负荷控制范围
      charger_peak: "", //	桩站负荷峰值
      charger_threshold: "", //	桩站负荷控制范围
      totalPowerW: "",
      powerChargingW: "",
      defaultArr: [
        {
          value: 0,
          name: "",
        },
      ],
      endTime1: "",
      endTime2: "",
      stationPowersTimeList: [],
      chargePowersTimeAllList: [],
      chargePowersTimeList: [],
      dataZoomStart: 0,
      dataZoomEnd: 100,
      dataZoomStart2: 0,
      dataZoomEnd2: 100,
      thresholdPrivilege: 1,
      socList: [
        {
          value: "95",
          label: "95%",
        },
        {
          value: "98",
          label: "98%",
        },
        {
          value: "100",
          label: "100%",
        },
      ],
      soc: "",
    };
  },
  mounted() {
    document.getElementsByTagName("body")[0].className = "electricity-body";
    let o = document.getElementById("power-threshold");
    this.width1 = o.clientWidth || o.offsetWidth;
    this.height1 = this.width1 / 1.195;
    let o2 = document.getElementById("power-ratio");
    this.width2 = o2.clientWidth || o2.offsetWidth;
    this.height2 = this.width2 / 1.105;
    let echartsW = document.getElementById("echart");
    //场站总功率宽度
    let w = document.getElementById("total-power-station");
    this.totalPowerW = w.clientWidth || w.offsetWidth;
    //充电桩功率宽度
    let k = document.getElementById("power-charging-pile");
    this.powerChargingW = k.clientWidth || k.offsetWidth;

    // debugger
    echartsW.style.height = this.height2 - 50 + "px";
    // let stationEchartW = document.getElementById("station-echart");
    // stationEchartW.style.height = this.height2 - 50 + "px";
    let pileEchartW = document.getElementById("pile-echart");
    pileEchartW.style.height = this.height2 - 50 + "px";

    this.$nextTick(function () {
      let role = [];
      role = this.$store.state.role;
      for (let i in role) {
        if (role[i].view_name == "实时监控") {
          for (let j in role[i].chlid) {
            if (role[i].chlid[j].view_name == "用电监控") {
              for (let m in role[i].chlid[j].method) {
                if (role[i].chlid[j].method[m].method_name == "设置阈值") {
                  this.thresholdPrivilege = 0;
                }
              }
            }
          }
        }
      }
      // console.log(this.thresholdPrivilege);

      this.getProvinces();
      this.timer = setInterval(() => {
        setTimeout(() => {
          this.getChargerPowerTime(this.stationId, this.chargersId);
          this.getStationPowersTime(this.stationId);
        }, 0);
      }, 20000);
    });
  },
  beforeCreate() {
    // document.getElementsByTagName("body")[0].className="electricity-body";
  },
  beforeDestroy() {
    document.body.removeAttribute("class", "electricity-body");
    clearInterval(this.timer);
    clearInterval(this.timer1);
    clearInterval(this.timer2);
    clearInterval(this.timer3);
  },
  computed: {
    isChangeMsg() {
      return this.$store.state.collapse;
    },
  },
  watch: {
    isChangeMsg(val) {
      let echart = echarts.init(document.getElementById("meter-echart"));
      let echart2 = echarts.init(document.getElementById("station-echart"));
      let echart3 = echarts.init(document.getElementById("pile-echart"));
      clearInterval(this.timer2);
      this.timer2 = setInterval(() => {
        setTimeout(function () {
          echart.resize();
          echart2.resize();
          echart3.resize();
        }, 0);
      }, 10);
    },
  },
  methods: {
    getProvinces() {
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
      };
      this.$api({
        method: "post",
        url: "/api.php/Currency/get_provinces",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.provincesList = su.data.list;
            // this.provincesName = this.provincesList[0].province;
           this.provincesName = this.$store.state.emProvinces?this.$store.state.emProvinces:this.provincesList[0].province;
            this.getCity2(this.$store.state.emProvinces?this.$store.state.emProvinces:this.provincesList[0].province);
          } else if (su.data.code == 0) {
            this.$message.warning(su.data.message);
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },
    getCity(province) {
      this.stationList=[]
      this.cityName = "";
      this.stationName = "";
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        province: province,
      };
      this.$api({
        method: "post",
        url: "/api.php/Currency/get_citys",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.cityList = su.data.list;
          } else if (su.data.code == 0) {
            this.$message.warning(su.data.message);
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },
    getCity2(province) {
      // this.cityName = "";
      this.cityList = [];
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        province: province,
      };
      this.$api({
        method: "post",
        url: "/api.php/Currency/get_citys",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.cityList = su.data.list;
            // this.cityName = this.cityList[0].city;
            // this.cityName = this.$store.state.eleCity? this.$store.state.eleCity: this.cityList[0].city;
             this.cityName = this.$store.state.emCity?this.$store.state.emCity:this.cityList[0].city;

            if (this.cityName == "信阳") {
              this.cityName = "信阳市";
            }
            // if (this.$store.state.eleCity == "信阳") {
            //   this.$store.state.eleCity = "信阳市";
            // }
            // this.getStations2(
            //   this.$store.state.eleCity
            //     ? this.$store.state.eleCity
            //     : this.cityList[0].city
            // );

           if(this.$store.state.emCity == "信阳"){
              this.$store.state.emCity = "信阳市";
            }
            this.getStations2(this.$store.state.emCity?this.$store.state.emCity:this.cityList[0].city);

          } else if (su.data.code == 0) {
            this.$message.warning(su.data.message);
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },
    getStations2(city) {
      // this.stationName = "";
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        city: city,
      };
      this.$api({
        method: "post",
        url: "/api.php/Currency/get_stations",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.stationList = su.data.list;

            // this.stationName = this.$store.state.eleStation
            //   ? this.$store.state.eleStation
            //   : this.stationList[0].station_id;
            // this.stationId = this.$store.state.eleStation
            //   ? this.$store.state.eleStation
            //   : this.stationList[0].station_id;

          this.stationName = this.$store.state.emStation?this.$store.state.emStation:this.stationList[0].station_name;
          this.stationId = this.$store.state.emStation?this.$store.state.emStation:this.stationList[0].station_id;

            this.getStationDetail(this.stationId);
            this.getSoc(this.stationId);
            this.getChargerPowerRate(this.stationId); //桩功率占比
            this.getElectricMeters(this.stationId); //电表电量
            this.getStationPowers(this.stationId); //场站总功率
            // console.log(this.stationId);
            this.getStationChargers(this.stationId);
            this.getChargerPowers(this.stationId, this.chargersId); //充电桩功率
            // debugger
          } else if (su.data.code == 0) {
            this.$message.warning(su.data.message);
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },

    cityChange(name) {
      this.stationName = "";
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        city: name,
      };
      this.$api({
        method: "post",
        url: "/api.php/Currency/get_stations",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.stationList = su.data.list;
          } else if (su.data.code == 0) {
            this.$message.warning(su.data.message);
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },
    stationChange(name) {
      // debugger
      // console.log(name);
      this.stationId = name;
      this.stationName = name;
      this.getStationDetail(this.stationId);
      this.getSoc(this.stationId);
      this.getChargerPowerRate(this.stationId); //桩功率占比
      this.getElectricMeters(this.stationId); //电表电量
      this.getStationPowers(this.stationId); //场站总功率
      this.getStationChargers(this.stationId);
      this.getChargerPowers(this.stationId, this.chargersId); //充电桩功率
      
      // this.$store.commit("changeEleProvinces", this.provincesName);
      // this.$store.commit("changeEleCity", this.cityName);
      // this.$store.commit("changeEleStation", this.stationId);


      this.$store.commit("changeEmProvinces", this.provincesName);
      this.$store.commit("changeEmCity", this.cityName);
      this.$store.commit("changeEmStation", this.stationId);
     
    },
    convertKey(arr, key) {
      let newArr = [];
      arr.forEach((item, index) => {
        let newObj = {};
        for (var i = 0; i < key.length; i++) {
          newObj[key[i]] = item[Object.keys(item)[i]];
        }
        newArr.push(newObj);
      });
      return newArr;
    },
    getChargerPowerRate(stationId) {
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        station_id: stationId,
      };
      this.$api({
        method: "post",
        url: "/api.php/ElectricMonitor/get_charger_power_rate",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.powerRateList = su.data.data;
            let arr = [];
            // if (this.powerRateList.length == 0) {
            //   arr = this.defaultArr;
            // } else if (this.powerRateList.length == 1) {
            //   for (let i in this.powerRateList) {
            //     // this.powerRateList[i].powers = Number(this.powerRateList[i].powers);
            //     let len = this.powerRateList[i].percent.length;
            //     this.powerRateList[i].percent = this.powerRateList[
            //       i
            //     ].percent.substring(0, len - 1);
            //     this.powerRateList[i].powers = Number(
            //       this.powerRateList[i].powers
            //     );
            //     // this.powerRateList[i].powers = Number(this.powerRateList[i].powers);
            //     arr.push({
            //       value: this.powerRateList[i].percent,
            //       powers: this.powerRateList[i].powers,
            //       name: this.powerRateList[i].charger_id,
            //     });
            //   }
            // } else {
            //   for (let i in this.powerRateList) {
            //     this.powerRateList[i].powers = this.powerRateList[
            //       i
            //     ].powers.substring(0, this.powerRateList[i].powers.length - 1);
            //     this.powerRateList[i].percent = Number(
            //       this.powerRateList[i].percent
            //     );
            //     // this.powerRateList[i].powers = Number(this.powerRateList[i].powers);
            //     arr.push({
            //       value: this.powerRateList[i].percent,
            //       powers: this.powerRateList[i].powers,
            //       name: this.powerRateList[i].charger_id,
            //     });
            //   }
            // }
            // debugger
            if(this.powerRateList.length==0){
              this.drawChart(this.defaultArr)
            }else{
              for(let i in this.powerRateList){
                arr.push({
                  value: this.powerRateList[i].powers,
                  name: this.powerRateList[i].charger_id,
                });
              }
            }
            this.drawChart(arr);
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.error(su.data.message);
          } else if (su.data.code ==304) {
            this.drawChart(this.defaultArr);

            // debugger
            // this.$message.warning(su.data.message);
          } else if (su.data.code == 900) {
          } else {
            this.drawChart(this.defaultArr);
          }
        })
        .catch((err) => {});
    },
    //桩功率占比
    drawChart(data) {
      let echart = echarts.init(document.getElementById("echart"));
      // 绘制图表
      var option = {
        title: {
          x: "center",
        },
        tooltip: {
          trigger: "item",
          textStyle: {
            align: "left",
          },
        formatter: '{a} <br/>{b} : {c} ({d}%)'
          // formatter: function (a, b, c) {
          //   var txtCon = "";
          //   if (a.name == "" && a.value == 0) {
          //     txtCon =
          //       "桩功率占比" +
          //       "<br/>" +
          //       "无最新桩功率" +
          //       " : " +
          //       0 +
          //       "(" +
          //       0 +
          //       "%" +
          //       ")";
          //   } else {
          //     txtCon =
          //       "桩功率占比" +
          //       "<br/>" +
          //       a.data.name +
          //       " : " +
          //       a.data.powers +
          //       "(" +
          //       a.data.value +
          //       "%" +
          //       ")";
              
          //   }
          //   return txtCon;
          // },
        },
        color: [
          "#2E7DD9",
          "#00C9DD",
          "#FF5A32",
          "#F601FF",
          "#5F5FFF",
          "#32B66B",
          "#FDCE5C",
          "#84D4DB",
          "#FF7A7B",
        ],
        legend: {
          show: false, // 去除显示图例
          formatter: "{b}",
        },
        series: [
          {
            name: "桩功率占比",
            type: "pie",
            radius: "60%",
            // radius: ["60%", "70%"],
            center: ["50%", "45%"],
            data: data,
            label: {
              normal: {
                textStyle: {
                  // color: "#5E6D82",
                  fontSize: 12,
                },
              },
            },
            labelLine: {
              normal: {
                lineStyle: {
                  // color: "#E0E6ED"
                },
              },
            },
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  formatter: function (a, b, c) {
                    // console.log(a);
                    var txtCon = "";
                    if (a.name == "") {
                      txtCon = "无最新桩功率";
                    } else {
                      txtCon = a.name;
                    }
                    return txtCon;
                  },
                },
              },
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
      echart.setOption(option);
    },
    doHandleMonth(month) {
      var m = month;
      if (month.toString().length == 1) {
        m = "0" + month;
      }
      return m;
    },
    getDay(day) {
      var today = new Date();
      var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
      today.setTime(targetday_milliseconds); //!!!
      var tYear = today.getFullYear();
      var tMonth = today.getMonth();
      var tDate = today.getDate();
      tMonth = this.doHandleMonth(tMonth + 1);
      tDate = this.doHandleMonth(tDate);
      return tMonth + "/" + tDate;
    },
    dateClick(num) {
      // debugger
      this.active = num;
      if (this.active == 1) {
        this.drawMeterEchart(
          this.metersData.hour_key,
          this.metersData.hour_charge
        );
      } else if (this.active == 2) {
        this.drawMeterEchart(
          this.metersData.day_key,
          this.metersData.day_charge
        );
      } else if (this.active == 3) {
        this.drawMeterEchart(
          this.metersData.month_key,
          this.metersData.month_charge
        );
      }
    },
        //电表电量
    getElectricMeters(stationId) {
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        station_id: stationId,
      };
      // debugger
      this.$api({
        method: "post",
        url: "/api.php/ElectricMonitor/get_electric_meters",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.metersData = su.data.data;
            // console.log(this.metersData.hour_charge);
            // console.log(this.metersData.hour_key);
            // debugger
            for (let i in this.metersData.day_key) {
              this.metersData.day_key[i] = this.metersData.day_key[i].substring(
                5,
                10
              );
            }
            if (this.metersData.hour_key.length == 0) {
              this.metersData.hour_key = [
                "00:00",
                "01:00",
                "02:00",
                "03:00",
                "04:00",
                "05:00",
                "06:00",
                "07:00",
                "08:00",
                "09:00",
                "10:00",
                "11:00",
                "12:00",
                "13:00",
                "14:00",
                "15:00",
                "16:00",
                "17:00",
                "18:00",
                "19:00",
                "20:00",
                "21:00",
                "22:00",
                "23:00",
              ];
            } else {
              for (let i in this.metersData.hour_key) {
                this.metersData.hour_key[i] = this.metersData.hour_key[
                  i
                ].substring(11, 16);
              }
            }
            for (let i in this.metersData.month_key) {
              this.metersData.month_key[i] = this.metersData.month_key[
                i
              ].substring(5, 10);
            }
            for (let i in this.metersData.day_charge) {
              if (this.metersData.day_charge[i] == null) {
                this.metersData.day_charge[i] = 0;
              }
            }
            if (this.metersData.hour_charge.length == 0) {
              this.metersData.hour_charge = [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
              ];
            } else {
              for (let i in this.metersData.hour_charge) {
                if (this.metersData.hour_charge[i] == null) {
                  this.metersData.hour_charge[i] = 0;
                }
              }
            }
            for (let i in this.metersData.month_charge) {
              if (this.metersData.month_charge[i] == null) {
                this.metersData.month_charge[i] = 0;
              }
            }
            if (this.active == 1) {
              this.drawMeterEchart(
                this.metersData.hour_key,
                this.metersData.hour_charge
              );
            } else if (this.active == 2) {
              this.drawMeterEchart(
                this.metersData.day_key,
                this.metersData.day_charge
              );
            } else if (this.active == 3) {
              this.drawMeterEchart(
                this.metersData.month_key,
                this.metersData.month_charge
              );
            }
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.error(su.data.message);
          } else {
            // debugger
            let arr1 = [
              "00:00",
              "01:00",
              "02:00",
              "03:00",
              "04:00",
              "05:00",
              "06:00",
              "07:00",
              "08:00",
              "09:00",
              "10:00",
              "11:00",
              "12:00",
              "13:00",
              "14:00",
              "15:00",
              "16:00",
              "17:00",
              "18:00",
              "19:00",
              "20:00",
              "21:00",
              "22:00",
              "23:00",
            ];
            // let arr3 = ["05-01", "05-02", "05-03", "05-04", "05-05", "05-06", "05-07", "05-08", "05-09", "05-10", "05-11", "05-12", "05-13", "05-14", "05-15"];
            let arr4 = [
              "01-01",
              "02-01",
              "03-01",
              "04-01",
              "05-01",
              "06-01",
              "07-01",
              "08-01",
              "09-01",
              "10-01",
              "11-01",
              "12-01",
            ];
            let arr5 = [];
            arr5.push(this.getDay(-1));
            arr5.push(this.getDay(-2));
            arr5.push(this.getDay(-3));
            arr5.push(this.getDay(-4));
            arr5.push(this.getDay(-5));
            arr5.push(this.getDay(-6));
            arr5.push(this.getDay(-7));
            arr5 = arr5.reverse();
            let arr2 = [
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
            ];
            this.metersData.hour_key = arr1;
            this.metersData.day_key = arr5;
            this.metersData.month_key = arr4;
            this.metersData.hour_charge = arr2;
            this.metersData.day_charge = arr2;
            this.metersData.month_charge = arr2;
            if (this.active == 1) {
              this.drawMeterEchart(arr1, arr2);
            } else if (this.active == 2) {
              this.drawMeterEchart(arr5, arr2);
            } else if (this.active == 3) {
              this.drawMeterEchart(arr4, arr2);
            }
          }
        })
        .catch((err) => {});
    },
    drawMeterEchart(key, charge) {
      // debugger
      let echart = echarts.init(document.getElementById("meter-echart"));
      // 绘制图表
      var option = {
        color: ["#EA551D"],
        tooltip: {
          trigger: "axis",
        },
        xAxis: {
          type: "category",
          // data: ["00.00","01.00","02.00","03.00","04.00","05.00","06.00","07.00","08.00","09.00","10.00","11.00","12.00","13.00","14.00","15.00","16.00","17.00","18.00","19.00","20.00"],
          data: key,
          axisLabel: {
            show: true,
            textStyle: {
              color: "#61CBFD", //更改坐标轴文字颜色
              fontSize: 10, //更改坐标轴文字大小
            },
            rotate: 60,
          },
          axisLine: {
            lineStyle: {
              color: "#07253F", //更改坐标轴颜色
            },
          },
          splitLine: {
            show: false,
          },
        },
        yAxis: {
          type: "value",
          axisLabel: {
            show: true,
            textStyle: {
              color: "#61CBFD", //更改坐标轴文字颜色
              fontSize: 10, //更改坐标轴文字大小
            },
          },
          axisLine: {
            lineStyle: {
              color: "#07253F", //更改坐标轴颜色
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: ["#07253F"],
            },
          },
        },
        grid: {
          containLabel: true,
          top: "10%",
          bottom: "8%", //距离下边距
          left: "3%",
          right: "2%",
        },
        series: [
          {
            // data: [11820, 11932, 1901, 934, 1290, 1330, 2320,820, 932, 901, 934, 1290, 1330, 2220, 932, 901, 934, 1290, 1330, 13020],
            data: charge,
            symbol: "none",
            type: "line",
            smooth: true,
          },
        ],
      };
      echart.setOption(option);
      clearInterval(this.timer1);
      this.timer1 = setInterval(() => {
        setTimeout(function () {
          window.onresize = function () {
            echart.resize();
          };
        }, 0);
      }, 100);
    },
        //场站总功率
    getStationPowers(stationId) {
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        station_id: stationId,
      };
      this.$api({
        method: "post",
        url: "/api.php/ElectricMonitor/get_station_powers",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.stationPowersTimeList = [];
            this.chargePowersTimeAllList = [];
            let length = su.data.data.length;
            // console.log(su.data.data.length);
            // debugger
            for (let o in su.data.data) {
              if (o == length - 1) {
                this.endTime2 = su.data.data[o].datetime;
              }
            }
            this.powerThreshold = su.data.power_threshold;
            // console.log(this.powerThreshold);
            if (su.data.data.length == 0) {
              this.stationPowers = [];
            } else {
              this.stationPowers = su.data.data;
            }
            var dateNum = new Date();
            var Ymd = dateNum.toLocaleDateString();
            let that = this;
            let date = [];
            let powersList = [];
            let charge_power_list = [];
            let powerThreshold = [];
            for (let i in that.stationPowers) {
              that.stationPowers[i].datetime = that.stationPowers[
                i
              ].datetime.substring(11, 19);
              if (that.stationPowers[i].charge_power_all == 0) {
                that.stationPowers[i].charge_power_all =
                  that.stationPowers[i].power;
              }
              date.push(that.stationPowers[i].datetime);
              let num = Ymd + " " + that.stationPowers[i].datetime;
              powersList.push([num, that.stationPowers[i].power]);
              charge_power_list.push([
                num,
                that.stationPowers[i].charge_power_all,
              ]);
            }
            this.stationPowersTimeList = powersList;
            this.chargePowersTimeAllList = charge_power_list;

            powerThreshold.push([Ymd + " 00:00:00", that.powerThreshold]);
            powerThreshold.push([Ymd + " 01:00:00", that.powerThreshold]);
            powerThreshold.push([Ymd + " 02:00:00", that.powerThreshold]);
            powerThreshold.push([Ymd + " 03:00:00", that.powerThreshold]);
            powerThreshold.push([Ymd + " 04:00:00", that.powerThreshold]);
            powerThreshold.push([Ymd + " 05:00:00", that.powerThreshold]);
            powerThreshold.push([Ymd + " 06:00:00", that.powerThreshold]);
            powerThreshold.push([Ymd + " 07:00:00", that.powerThreshold]);
            powerThreshold.push([Ymd + " 08:00:00", that.powerThreshold]);
            powerThreshold.push([Ymd + " 09:00:00", that.powerThreshold]);
            powerThreshold.push([Ymd + " 10:00:00", that.powerThreshold]);
            powerThreshold.push([Ymd + " 11:00:00", that.powerThreshold]);
            powerThreshold.push([Ymd + " 12:00:00", that.powerThreshold]);
            powerThreshold.push([Ymd + " 13:00:00", that.powerThreshold]);
            powerThreshold.push([Ymd + " 14:00:00", that.powerThreshold]);
            powerThreshold.push([Ymd + " 15:00:00", that.powerThreshold]);
            powerThreshold.push([Ymd + " 16:00:00", that.powerThreshold]);
            powerThreshold.push([Ymd + " 17:00:00", that.powerThreshold]);
            powerThreshold.push([Ymd + " 18:00:00", that.powerThreshold]);
            powerThreshold.push([Ymd + " 19:00:00", that.powerThreshold]);
            powerThreshold.push([Ymd + " 20:00:00", that.powerThreshold]);
            powerThreshold.push([Ymd + " 21:00:00", that.powerThreshold]);
            powerThreshold.push([Ymd + " 22:00:00", that.powerThreshold]);
            powerThreshold.push([Ymd + " 23:00:00", that.powerThreshold]);
            powerThreshold.push([Ymd + " 23:59:00", that.powerThreshold]);
            this.drawStationEchart(
              date,
              powersList,
              charge_power_list,
              powerThreshold
            );
            // debugger
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.error(su.data.message);
          } else if (su.data.code == 900) {
          } else {
            this.$message.error(su.data.message);
          }
        })
        .catch((err) => {});
    },
    drawStationEchart(date, powersList, charge_power_list, powerThreshold) {
      // console.log(charge_power_list);
      if (powersList.length > 0) {
        // let time1 = new Date(powersList[0].datetime).getTime();
        let time2 = "";

        for (let j = 0; j < powersList.length - 1; j++) {
          // if(new Date(powersList[j].datetime).getTime() - time1 > 18000 && powersList[j].power > 0){
          if (
            new Date(powersList[j + 1][0]).getTime() -
              new Date(powersList[j][0]).getTime() >
            24000
          ) {
            // let date = new Date(time1 + 6000);
            let date = new Date(new Date(powersList[j][0]).getTime() + 12000);
            let seperator1 = "-";
            let seperator2 = ":";

            let month =
              date.getMonth() + 1 < 10
                ? "0" + (date.getMonth() + 1)
                : date.getMonth() + 1;
            let strDate =
              date.getDate() < 10 ? "0" + date.getDate() : date.getDate();

            let getHours =
              date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
            let getMinutes =
              date.getMinutes() < 10
                ? "0" + date.getMinutes()
                : date.getMinutes();
            let getSeconds =
              date.getSeconds() < 10
                ? "0" + date.getSeconds()
                : date.getSeconds();

            let currentdate =
              date.getFullYear() +
              seperator1 +
              month +
              seperator1 +
              strDate +
              " " +
              getHours +
              seperator2 +
              getMinutes +
              seperator2 +
              getSeconds;

            let date2 = new Date(
              new Date(powersList[j + 1][0]).getTime() - 12000
            );
            let seperator3 = "-";
            let seperator4 = ":";

            let month2 =
              date2.getMonth() + 1 < 10
                ? "0" + (date2.getMonth() + 1)
                : date2.getMonth() + 1;
            let strDate2 =
              date2.getDate() < 10 ? "0" + date2.getDate() : date2.getDate();

            let getHours2 =
              date2.getHours() < 10 ? "0" + date2.getHours() : date2.getHours();
            let getMinutes2 =
              date2.getMinutes() < 10
                ? "0" + date2.getMinutes()
                : date2.getMinutes();
            let getSeconds2 =
              date2.getSeconds() < 10
                ? "0" + date2.getSeconds()
                : date2.getSeconds();

            let currentdate2 =
              date2.getFullYear() +
              seperator3 +
              month2 +
              seperator3 +
              strDate2 +
              " " +
              getHours2 +
              seperator4 +
              getMinutes2 +
              seperator4 +
              getSeconds2;

            powersList.splice(j + 1, 0, [currentdate, "0"]);
            powersList.splice(j + 2, 0, [currentdate2, "0"]);
            // j = j+2;
          }
          // time1 = new Date(powersList[j].datetime).getTime();
        }
        // this.$forceUpdate();
        // console.log(11);
      }

      if (charge_power_list.length > 0) {
        // let time1 = new Date(charge_power_list[0].datetime).getTime();
        let time2 = "";

        for (let j = 0; j < charge_power_list.length - 1; j++) {
          // if(new Date(charge_power_list[j].datetime).getTime() - time1 > 18000 && charge_power_list[j].power > 0){
          if (
            new Date(charge_power_list[j + 1][0]).getTime() -
              new Date(charge_power_list[j][0]).getTime() >
            24000
          ) {
            // let date = new Date(time1 + 6000);
            let date = new Date(
              new Date(charge_power_list[j][0]).getTime() + 12000
            );
            let seperator1 = "-";
            let seperator2 = ":";

            let month =
              date.getMonth() + 1 < 10
                ? "0" + (date.getMonth() + 1)
                : date.getMonth() + 1;
            let strDate =
              date.getDate() < 10 ? "0" + date.getDate() : date.getDate();

            let getHours =
              date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
            let getMinutes =
              date.getMinutes() < 10
                ? "0" + date.getMinutes()
                : date.getMinutes();
            let getSeconds =
              date.getSeconds() < 10
                ? "0" + date.getSeconds()
                : date.getSeconds();

            let currentdate =
              date.getFullYear() +
              seperator1 +
              month +
              seperator1 +
              strDate +
              " " +
              getHours +
              seperator2 +
              getMinutes +
              seperator2 +
              getSeconds;

            let date2 = new Date(
              new Date(charge_power_list[j + 1][0]).getTime() - 12000
            );
            let seperator3 = "-";
            let seperator4 = ":";

            let month2 =
              date2.getMonth() + 1 < 10
                ? "0" + (date2.getMonth() + 1)
                : date2.getMonth() + 1;
            let strDate2 =
              date2.getDate() < 10 ? "0" + date2.getDate() : date2.getDate();

            let getHours2 =
              date2.getHours() < 10 ? "0" + date2.getHours() : date2.getHours();
            let getMinutes2 =
              date2.getMinutes() < 10
                ? "0" + date2.getMinutes()
                : date2.getMinutes();
            let getSeconds2 =
              date2.getSeconds() < 10
                ? "0" + date2.getSeconds()
                : date2.getSeconds();

            let currentdate2 =
              date2.getFullYear() +
              seperator3 +
              month2 +
              seperator3 +
              strDate2 +
              " " +
              getHours2 +
              seperator4 +
              getMinutes2 +
              seperator4 +
              getSeconds2;

            charge_power_list.splice(j + 1, 0, [currentdate, "0"]);
            charge_power_list.splice(j + 2, 0, [currentdate2, "0"]);
            // j = j+2;
          }
          // time1 = new Date(charge_power_list[j].datetime).getTime();
        }
        // this.$forceUpdate();
        // console.log(11);
      }

      // console.log(charge_power_list);

      var date = new Date();
      var Ymd = date.toLocaleDateString();
      // debugger
      let echart = echarts.init(document.getElementById("station-echart"));
      // 绘制图表
      var option = {
        color: ["#32B768", "#FF5A32", "#07b4c5", "#F7F01C"],
        tooltip: {
          trigger: "axis",
          formatter:function(params,a){                     //自定义提示
            let txtCon='<div>'
            if(params.length==1){
              txtCon+=params[0].data[0]+"<br/>"                         //提示标题
              txtCon+=params[0].marker                                 //提示文本前的圆点marker
              // txtCon+='<span style="color:'+params[0].color+'">'       //提示文本颜色
              txtCon+=params[0].seriesName+":"+params[0].data[1]+'</div>'  //提示项目名字：值
            }else if(params.length==4){
              txtCon+=params[0].data[0]+"<br/>"                          //提示标题
               txtCon+=params[0].marker                                 //提示文本前的圆点marker
                txtCon+=params[0].seriesName+":"+params[0].data[1]+'</br>'  //提示项目名字：值
                txtCon+=params[3].marker                                 //提示文本前的圆点marker
                txtCon+=params[3].seriesName+":"+params[3].data[1]+'</div>'  //提示项目名字：值
            }
            return txtCon;
          }
        },
        legend: {
          top: 20,
          right: "14%",
          itemWidth: 10, // 图例图形宽度
          itemHeight: 10,
          itemGap: 20,
          data: [
            {
              name: "功率阈值",
              icon: "circle",
              textStyle: {
                symbolSize: 10,
                color: "#62C6FF", // 图例文字颜色
                fontSize: 10,
              },
            },
            {
              name: "场站总功率",
              icon: "circle",
              textStyle: {
                color: "#62C6FF", // 图例文字颜色
                fontSize: 10,
              },
            },
            {
              name: "桩总功率",
              icon: "circle",
              textStyle: {
                color: "#62C6FF", // 图例文字颜色
                fontSize: 10,
              },
            },
          ],
        },
        grid: {
          containLabel: true,
          top: "22%", //距上边距
          bottom: this.totalPowerW < 600 ? "18%" : "12%", //距离下边距
          right: "3%",
          left: "2%",
        },
        xAxis: {
          // type: "category",
          // boundaryGap: false,
          // data: date,
          // data:key,
          type: "time",
          min: Ymd + " 00:00:00",
          max: Ymd + " 23:59:00",
          interval: 1 * 60 * 60 * 1000,
          axisLabel: {
            show: true,
            textStyle: {
              color: "#61CBFD", //更改坐标轴文字颜色
              fontSize: 10, //更改坐标轴文字大小
            },
            rotate: 60,
            formatter: function (v) {
              var date = new Date(v);
              return `${("0" + date.getHours()).slice(-2)}:${(
                "0" + date.getMinutes()
              ).slice(-2)}`;
            },
          },
          axisLine: {
            lineStyle: {
              color: "#07253F", //更改坐标轴颜色
            },
          },
          splitLine: {
            show: false,
          },
        },
        yAxis: {
          type: "value",
          axisLabel: {
            show: true,
            textStyle: {
              color: "#61CBFD", //更改坐标轴文字颜色
              fontSize: 10, //更改坐标轴文字大小
            },
          },
          axisLine: {
            lineStyle: {
              color: "#07253F", //更改坐标轴颜色
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: ["#07253F"],
            },
          },
        },
        dataZoom: [
          {
            type: "slider", //图表下方的滚动条
            borderColor: "#06537F",
            fillerColor: "#002C45", //选中范围的填充颜色。
            show: true, //是否显示
            start: this.dataZoomStart, //滚动条开始位置（1-100）
            end: this.dataZoomEnd, //滚动条结束位置（1-100）
            bottom: this.totalPowerW < 666 ? 8 : 8,
            height: this.totalPowerW < 732 ? 15 : 28,
            left: "3%",
          },
        ],
        series: [
          {
            data: powersList,
            name: "场站总功率",
            type: "line",
            symbol: "none",
            smooth: true,
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#0E303C",
                  },
                ]),
              },
            },
          },
          {
            data: charge_power_list,
            name: "桩总功率",
            type: "line",
            symbol: "none",
            // smooth: true,
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#0E303C",
                  },
                ]),
              },
            },
          },
          {
            name: "功率阈值",
            type: "line",
            symbol: "none", //去掉折线中间的圆点
            data: powerThreshold,
          },
        ],
      };

      var self = this;
      echart.on("datazoom", function (params) {
        self.dataZoomStart = params.start;
        self.dataZoomEnd = params.end;
      });

      echart.setOption(option);

      clearInterval(this.timer2);
      this.timer2 = setInterval(() => {
        setTimeout(function () {
          window.onresize = function () {
            echart.resize();
          };
        }, 0);
      }, 100);
    },
        // 充电桩功率
    getChargerPowers(stationId, chargersId) {
      // debugger
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        station_id: stationId,
        charger_id: chargersId,
      };
      this.$api({
        method: "post",
        url: "/api.php/ElectricMonitor/get_charger_power",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            // debugger
            this.chargePowersTimeList = [];
            let length = su.data.data.length;
            // length = length-1;
            // debugger
            for (let o in su.data.data) {
              if (o == length - 1) {
                this.endTime1 = su.data.data[o].datetime;
              }
            }

            if (su.data.data.length == 0) {
              this.chargerPower = [];
            } else {
              this.chargerPower = su.data.data;
            }
            var dateNum = new Date();
            var Ymd = dateNum.toLocaleDateString();
            let that = this;
            let date = [];
            let powersList = [];
            for (let i in that.chargerPower) {
              that.chargerPower[i].datetime = that.chargerPower[
                i
              ].datetime.substring(11, 19);
              date.push(that.chargerPower[i].datetime);
              // powersList.push(this.chargerPower[i].power);
              let num = Ymd + " " + that.chargerPower[i].datetime;
              powersList.push([num, that.chargerPower[i].power]);
            }
            this.chargePowersTimeList = powersList;
            // console.log(date);
            // console.log(powersList);
            // console.log(powerThreshold);
            this.drawPileEchart(date, powersList);
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.error(su.data.message);
          } else if (su.data.code == 302) {
            this.chargerPower = [];
            var dateNum = new Date();
            var Ymd = dateNum.toLocaleDateString();
            let that = this;
            let date = [];
            let powersList = [];
            for (let i in that.chargerPower) {
              that.chargerPower[i].datetime = that.chargerPower[
                i
              ].datetime.substring(11, 19);
              date.push(that.chargerPower[i].datetime);
              // powersList.push(this.chargerPower[i].power);
              let num = Ymd + " " + that.chargerPower[i].datetime;
              powersList.push([num, that.chargerPower[i].power]);
            }

            // console.log(date);
            // console.log(powersList);
            // console.log(powerThreshold);
            this.drawPileEchart(date, powersList);
          }
        })
        .catch((err) => {});
    },
    drawPileEchart(date, powersList) {
      if (powersList.length > 0) {
        // let time1 = new Date(powersList[0].datetime).getTime();
        let time2 = "";

        for (let j = 0; j < powersList.length - 1; j++) {
          // if(new Date(powersList[j].datetime).getTime() - time1 > 18000 && powersList[j].power > 0){
          if (
            new Date(powersList[j + 1][0]).getTime() -
              new Date(powersList[j][0]).getTime() >
            24000
          ) {
            // let date = new Date(time1 + 6000);
            let date = new Date(new Date(powersList[j][0]).getTime() + 12000);
            let seperator1 = "-";
            let seperator2 = ":";

            let month =
              date.getMonth() + 1 < 10
                ? "0" + (date.getMonth() + 1)
                : date.getMonth() + 1;
            let strDate =
              date.getDate() < 10 ? "0" + date.getDate() : date.getDate();

            let getHours =
              date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
            let getMinutes =
              date.getMinutes() < 10
                ? "0" + date.getMinutes()
                : date.getMinutes();
            let getSeconds =
              date.getSeconds() < 10
                ? "0" + date.getSeconds()
                : date.getSeconds();

            let currentdate =
              date.getFullYear() +
              seperator1 +
              month +
              seperator1 +
              strDate +
              " " +
              getHours +
              seperator2 +
              getMinutes +
              seperator2 +
              getSeconds;

            let date2 = new Date(
              new Date(powersList[j + 1][0]).getTime() - 12000
            );
            let seperator3 = "-";
            let seperator4 = ":";

            let month2 =
              date2.getMonth() + 1 < 10
                ? "0" + (date2.getMonth() + 1)
                : date2.getMonth() + 1;
            let strDate2 =
              date2.getDate() < 10 ? "0" + date2.getDate() : date2.getDate();

            let getHours2 =
              date2.getHours() < 10 ? "0" + date2.getHours() : date2.getHours();
            let getMinutes2 =
              date2.getMinutes() < 10
                ? "0" + date2.getMinutes()
                : date2.getMinutes();
            let getSeconds2 =
              date2.getSeconds() < 10
                ? "0" + date2.getSeconds()
                : date2.getSeconds();

            let currentdate2 =
              date2.getFullYear() +
              seperator3 +
              month2 +
              seperator3 +
              strDate2 +
              " " +
              getHours2 +
              seperator4 +
              getMinutes2 +
              seperator4 +
              getSeconds2;

            powersList.splice(j + 1, 0, [currentdate, "0"]);
            powersList.splice(j + 2, 0, [currentdate2, "0"]);
            // j = j+2;
          }
          // time1 = new Date(powersList[j].datetime).getTime();
        }
        // this.$forceUpdate();
        // console.log(11);
      }

      // console.log(powersList);

      var date = new Date();
      var Ymd = date.toLocaleDateString();
      let echart = echarts.init(document.getElementById("pile-echart"));
      // 绘制图表
      var option = {
        color: ["#605EFD"],
        tooltip: {
          trigger: "axis",
        },
        grid: {
          containLabel: true,
          top: "8%", //距上边距
          bottom: this.powerChargingW < 600 ? "18%" : "18%", //距离下边距
          right: "3%",
          left: "6%",
        },
        xAxis: {
          type: "time",
          // boundaryGap: false,
          // data: date,
          // data:key,
          min: Ymd + " 00:00:00",
          max: Ymd + " 23:59:00",
          interval: 1 * 60 * 60 * 1000,
          axisLabel: {
            show: true,
            textStyle: {
              color: "#61CBFD", //更改坐标轴文字颜色
              fontSize: 10, //更改坐标轴文字大小
            },
            rotate: 60,
            formatter: function (v) {
              var date = new Date(v);
              return `${("0" + date.getHours()).slice(-2)}:${(
                "0" + date.getMinutes()
              ).slice(-2)}`;
            },
          },
          axisLine: {
            lineStyle: {
              color: "#07253F", //更改坐标轴颜色
            },
          },
          splitLine: {
            show: false,
          },
        },
        yAxis: {
          type: "value",
          axisLabel: {
            show: true,
            textStyle: {
              color: "#61CBFD", //更改坐标轴文字颜色
              fontSize: 10, //更改坐标轴文字大小
            },
          },
          axisLine: {
            lineStyle: {
              color: "#07253F", //更改坐标轴颜色
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: ["#07253F"],
            },
          },
        },
        dataZoom: [
          {
            type: "slider", //图表下方的滚动条
            borderColor: "#06537F",
            fillerColor: "#002C45", //选中范围的填充颜色。
            show: true, //是否显示
            realtime: true, //
            start: this.dataZoomStart2, //滚动条开始位置（1-100）
            end: this.dataZoomEnd2, //滚动条结束位置（1-100）
            left: "4%",
            // startValue: "00:00",
            // endValue: "23:59",
            bottom: this.powerChargingW < 732 ? 20 : 28,
            height: this.powerChargingW < 732 ? 15 : 28,
          },
        ],
        series: [
          {
            data: powersList,
            // data:charge,
            name: "充电桩功率",
            type: "line",
            symbol: "none",
            smooth: true,
            areaStyle: {
              //折线下面覆盖颜色
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#6665FF",
                  },
                ]),
              },
            },
          },
        ],
      };

      var self = this;
      echart.on("datazoom", function (params) {
        self.dataZoomStart2 = params.start;
        self.dataZoomEnd2 = params.end;
      });

      echart.setOption(option);
      clearInterval(this.timer3);
      this.timer3 = setInterval(() => {
        setTimeout(function () {
          window.onresize = function () {
            echart.resize();
          };
        }, 0);
      }, 100);
    },
    getStationChargers(stationId) {
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        station_id: stationId,
      };
      this.$api({
        method: "post",
        url: "/api.php/ElectricMonitor/get_station_chargers",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.chargersList = su.data.data;

            if (this.chargersList.length == 0) {
              this.chargersName = "";
              this.chargersId = "";
            } else {
              this.chargersId = this.chargersList[0].charger_id;
              this.chargersName = this.chargersList[0].charger_name;
            }
            // debugger
            // console.log(this.stationId);
            // console.log(this.chargersId);
            this.getChargerPowers(this.stationId, this.chargersId);
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.error(su.data.message);
          } else if (su.data.code == 900) {
          } else {
            this.$message.error(su.data.message);
          }
        })
        .catch((err) => {});
    },
    stationChargersChange(chargersId) {
      this.chargersId = chargersId;
      this.getChargerPowers(this.stationId, chargersId);
      this.$store.commit("changeEleChargers", this.chargersName);
    },
    saveStationDetail() {
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        station_id: this.stationId,
        station_peak: this.station_peak,
        station_threshold: this.station_threshold,
        charger_peak: this.charger_peak,
        charger_threshold: this.charger_threshold,
      };
      this.$api({
        method: "post",
        url: "/api.php/ElectricMonitor/save_station_detail",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.getStationPowers(this.stationId);
            this.$message.success(su.data.message);
            // this.station_peak = "";
            // this.station_threshold = "";
            // this.charger_peak = "";
            // this.charger_threshold = "";
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.error(su.data.message);
          } else if (su.data.code == 900) {
          } else {
            this.$message.error(su.data.message);
          }
        })
        .catch((err) => {});
    },
    getStationDetail(stationId) {
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        station_id: stationId,
      };
      this.$api({
        method: "post",
        url: "/api.php/ElectricMonitor/get_station_detail",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.station_peak = Math.round(su.data.data.station_peak);
            this.station_threshold = su.data.data.station_threshold;
            this.charger_peak = Math.round(su.data.data.charger_peak);
            this.charger_threshold = su.data.data.charger_threshold;
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.error(su.data.message);
          } else if (su.data.code == 900) {
          } else {
            this.$message.error(su.data.message);
          }
        })
        .catch((err) => {});
    },
    getChargerPowerTime(stationId, chargersId) {
      let date = new Date();
      let seperator1 = "-";
      let seperator2 = ":";

      let month =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      let strDate = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();

      let getHours =
        date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      let getMinutes =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      let getSeconds =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();

      let currentdate =
        date.getFullYear() +
        seperator1 +
        month +
        seperator1 +
        strDate +
        " " +
        getHours +
        seperator2 +
        getMinutes +
        seperator2 +
        getSeconds;
      // debugger
      if (this.endTime1 == "" || this.endTime1 == undefined) {
        this.endTime1 = currentdate;
      }
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        station_id: stationId,
        charger_id: chargersId,
        end_time: this.endTime1,
      };
      this.$api({
        method: "post",
        url: "/api.php/ElectricMonitor/get_charger_power_time",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            // console.log(this.chargerPower);
            let addArr = [];
            addArr = su.data.data;
            let length = addArr.length;
            // debugger
            if (length == 0) {
              this.endTime1 = this.endTime1;
            } else {
              for (let o in addArr) {
                if (o == length - 1) {
                  this.endTime1 = addArr[o].datetime;
                }
              }
            }
           
            var dateNum = new Date();
            var Ymd = dateNum.toLocaleDateString();
            let that = this;
            let date = [];
            let powersList = [];
            for (let i in addArr) {
              addArr[i].datetime = addArr[i].datetime.substring(11, 19);
              date.push(addArr[i].datetime);
              let num = Ymd + " " + addArr[i].datetime;
              this.chargePowersTimeList.push([num, addArr[i].power]);
            }
            

            this.drawPileEchart(date, this.chargePowersTimeList);
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.error(su.data.message);
          } else if (su.data.code == 302) {
            // console.log(1);
          } else if (su.data.code == 900) {
          } else {
            this.$message.error(su.data.message);
          }
        })
        .catch((err) => {});
    },
    getStationPowersTime(stationId) {
      let date = new Date();
      // console.log(time1);
      let seperator1 = "-";
      let seperator2 = ":";

      let month =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      let strDate = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();

      let getHours =
        date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      let getMinutes =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      let getSeconds =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();

      let currentdate =
        date.getFullYear() +
        seperator1 +
        month +
        seperator1 +
        strDate +
        " " +
        getHours +
        seperator2 +
        getMinutes +
        seperator2 +
        getSeconds;
      // debugger
      if (this.endTime2 == "" || this.endTime2 == undefined) {
        this.endTime2 = currentdate;
      }
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        station_id: stationId,
        end_time: this.endTime2,
      };
      this.$api({
        method: "post",
        url: "/api.php/ElectricMonitor/get_station_powers_time",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            let addArr2 = [];
            addArr2 = su.data.data;
            let length = addArr2.length;
            // debugger
            if (length == 0) {
              this.endTime2 = this.endTime2;
            } else {
              for (let o in addArr2) {
                if (o == length - 1) {
                  this.endTime2 = addArr2[o].datetime;
                }
              }
            }

            this.powerThreshold = su.data.power_threshold;
            // if(su.data.data.length==0){
            //   this.stationPowers = [];
            // } else {
            //   for(let i in addArr2){
            //     this.stationPowers.push(addArr2[i]);
            //   }
            //   // this.stationPowers = su.data.data;
            // }
            var dateNum = new Date();
            var Ymd = dateNum.toLocaleDateString();
            let that = this;
            let date = [];
            let powersList = [];
            let powerThreshold = [];
            for (let i in addArr2) {
              addArr2[i].datetime = addArr2[i].datetime.substring(11, 19);
              date.push(addArr2[i].datetime);
              let num = Ymd + " " + addArr2[i].datetime;
              that.stationPowersTimeList.push([num, addArr2[i].power]);
              that.chargePowersTimeAllList.push([
                num,
                addArr2[i].charge_power_all,
              ]);
              // powerThreshold.push(that.powerThreshold);
            }
            // if(powersList.length > 0){
            //   for(let i in powersList){
            //     this.stationPowers.push(powersList[i]);
            //   }
            // }

            powerThreshold.push([Ymd + " 00:00:00", that.powerThreshold]);
            powerThreshold.push([Ymd + " 01:00:00", that.powerThreshold]);
            powerThreshold.push([Ymd + " 02:00:00", that.powerThreshold]);
            powerThreshold.push([Ymd + " 03:00:00", that.powerThreshold]);
            powerThreshold.push([Ymd + " 04:00:00", that.powerThreshold]);
            powerThreshold.push([Ymd + " 05:00:00", that.powerThreshold]);
            powerThreshold.push([Ymd + " 06:00:00", that.powerThreshold]);
            powerThreshold.push([Ymd + " 07:00:00", that.powerThreshold]);
            powerThreshold.push([Ymd + " 08:00:00", that.powerThreshold]);
            powerThreshold.push([Ymd + " 09:00:00", that.powerThreshold]);
            powerThreshold.push([Ymd + " 10:00:00", that.powerThreshold]);
            powerThreshold.push([Ymd + " 11:00:00", that.powerThreshold]);
            powerThreshold.push([Ymd + " 12:00:00", that.powerThreshold]);
            powerThreshold.push([Ymd + " 13:00:00", that.powerThreshold]);
            powerThreshold.push([Ymd + " 14:00:00", that.powerThreshold]);
            powerThreshold.push([Ymd + " 15:00:00", that.powerThreshold]);
            powerThreshold.push([Ymd + " 16:00:00", that.powerThreshold]);
            powerThreshold.push([Ymd + " 17:00:00", that.powerThreshold]);
            powerThreshold.push([Ymd + " 18:00:00", that.powerThreshold]);
            powerThreshold.push([Ymd + " 19:00:00", that.powerThreshold]);
            powerThreshold.push([Ymd + " 20:00:00", that.powerThreshold]);
            powerThreshold.push([Ymd + " 21:00:00", that.powerThreshold]);
            powerThreshold.push([Ymd + " 22:00:00", that.powerThreshold]);
            powerThreshold.push([Ymd + " 23:00:00", that.powerThreshold]);
            powerThreshold.push([Ymd + " 23:59:00", that.powerThreshold]);
            // console.log(this.stationPowersTimeList);

            this.drawStationEchart(
              date,
              this.stationPowersTimeList,
              this.chargePowersTimeAllList,
              powerThreshold
            );
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.error(su.data.message);
          } else if (su.data.code == 302) {
            // console.log(1);
          } else if (su.data.code == 900) {
          } else {
            this.$message.error(su.data.message);
          }
        })
        .catch((err) => {});
    },
    socClick() {
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action: "save_soc",
        station_id: this.stationId,
        soc: Number(this.soc),
      };
      this.$api({
        method: "post",
        url: "/api.php/ElectricMonitor/save_soc",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.$message.success(su.data.message);
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.error(su.data.message);
          } else if (su.data.code == 900) {
            this.$message.error(su.data.message);
          } else if (su.data.code == 0) {
            this.$message.warning(su.data.message);
          } else {
            this.$message.error(su.data.message);
          }
        })
        .catch((err) => {});
    },
    getSoc(id) {
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action: "get_soc",
        station_id: id,
      };
      this.$api({
        method: "post",
        url: "/api.php/ElectricMonitor/get_soc",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.soc = su.data.data.soc;
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.error(su.data.message);
          } else if (su.data.code == 900) {
            this.$message.error(su.data.message);
          } else if (su.data.code == 0) {
            this.$message.warning(su.data.message);
          } else {
            this.$message.error(su.data.message);
          }
        })
        .catch((err) => {});
    },
  },
};
</script>

<style scoped lang="scss">
.electricity {
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -khtml-user-select: none;
  -o-user-select: none;
  user-select: none;
  .electricity-top {
    width: 98%;
    margin-left: 1%;
    height: 62px;
    background-color: #0c202b;
    margin-top: 18px;
    // display: flex;
    // align-items: center;
    .top-left {
      color: #feffff;
      float: left;
      line-height: 62px;
      margin-left: 20px;
    }
    .top-right {
      float: right;
      margin-right: 20px;
      margin-top: 15px;
    }
  }
  .electricity-bottom {
    .power-threshold {
      // display: inline-block;
      width: 24%;
      background: url(../../assets/img/ydjk_01.png) no-repeat;
      background-size: 100% 100%;
      margin-top: 20px;
      margin-left: 1%;
      float: left;
      .threshold-title {
        font-size: 16px;
        font-family: "microsoft yahei";
        color: #fffeff;
        text-align: left;
        margin-left: 10%;
        margin-top: 22px;
      }
      .threshold-content {
        margin-top: 30px;
        .box {
          display: block;
          margin-bottom: 16px;
          width: 100%;
          .content-input {
            display: inline-block;
            width: 44%;
            vertical-align: top;
            position: relative;
            span {
              color: #60c7ff;
              font-size: 12px;
              vertical-align: top;
              position: relative;
              top: 6px;
            }
            .el-input {
              width: 40%;
              overflow: hidden;
              white-space: nowrap; /*不显示的地方用省略号...代替*/
              text-overflow: ellipsis;
              .el-input__inner {
                padding-right: 0;
              }
            }
          }
        }
        .save-btn {
          width: 24%;
          float: left;
          margin-left: 5%;
          .el-button {
            width: 100%;
            background-color: #2e7dd9;
            color: #fffeff;
            border: none;
            font-family: "microsoft yahei";
            padding: 8px 8px;
          }
          .el-button.active {
            background-color: #a5a5a5;
          }
        }
      }
      .line-line {
        width: 90%;
        margin-left: 5%;
        height: 1px;
        background-color: #135a69;
        margin-top: 18px;
        margin-bottom: 18px;
      }
      .soc {
        float: left;
        width: 79%;
        .content-input {
          float: left;
          width: 90%;
          span {
            color: #60c7ff;
            font-size: 12px;
          }
          .el-select {
            width: 60%;
          }
        }
        .save-btn {
          width: 30%;
          float: left;
          margin-left: 6%;
          margin-top: 20px;
          .el-button {
            width: 100%;
            background-color: #2e7dd9;
            color: #fffeff;
            border: none;
            font-family: "microsoft yahei";
            padding: 8px 8px;
          }
          .el-button.active {
            background-color: #a5a5a5;
          }
        }
      }
    }
    .power-ratio {
      width: 24%;
      background: url(../../assets/img/ydjk_01.png) no-repeat;
      background-size: 100% 100%;
      margin-top: 20px;
      margin-left: 1%;
      float: left;
      .ratio-title {
        font-size: 16px;
        font-family: "microsoft yahei";
        color: #fffeff;
        text-align: left;
        margin-left: 10%;
        margin-top: 22px;
      }
    }
    .watt-hour-meter {
      width: 48%;
      background: url(../../assets/img/ydjk_02.png) no-repeat;
      background-size: 100% 100%;
      margin-top: 20px;
      margin-left: 1%;
      float: left;
      overflow: hidden;
      .meter-title {
        float: left;
        font-size: 16px;
        font-family: "microsoft yahei";
        color: #fffeff;
        text-align: left;
        margin-left: 6%;
        margin-top: 22px;
      }
      .right-btn {
        float: right;
        flex-grow: 1;
        z-index: 9999;
        margin-top: 22px;
        margin-right: 14%;
        span {
          color: #666666;
          cursor: pointer;
        }
        span.active {
          color: #0078c1;
        }
      }
      #meter-echart {
        margin-top: 50px;
        // z-index: 1;
      }
    }
    .total-power-station {
      width: 49%;
      background: url(../../assets/img/ydjk_02.png) no-repeat;
      background-size: 100% 100%;
      margin-top: 20px;
      margin-left: 1%;
      float: left;
      overflow: hidden;
      .station-title {
        float: left;
        font-size: 16px;
        font-family: "microsoft yahei";
        color: #fffeff;
        text-align: left;
        margin-left: 5%;
        margin-top: 22px;
      }
    }
    .power-charging-pile {
      width: 48%;
      background: url(../../assets/img/ydjk_02.png) no-repeat;
      background-size: 100% 100%;
      margin-top: 20px;
      margin-left: 1%;
      float: left;
      overflow: hidden;
      .pile-title {
        float: left;
        font-size: 16px;
        font-family: "microsoft yahei";
        color: #fffeff;
        text-align: left;
        margin-left: 5%;
        margin-top: 22px;
      }
      .pile-select {
        // float: right;
        // display: inline-block;
        margin-left: 55%;
        .el-select {
          width: 130px;
          // height: 28px;
          margin-top: 10px;
          .el-input__inner {
            color: #5fc6ff !important;
          }
        }
      }
    }
  }
}
@media screen and (min-width: 1540px) and (max-width: 1680px) {
  .electricity {
    .electricity-bottom {
      .power-threshold {
        .threshold-content {
          .box {
            .content-input {
              width: 48%;
            }
          }
          .save-btn {
            margin-left: 3%;
          }
        }
        .line-line {
          margin-bottom: 10px;
        }
        .soc {
          .save-btn {
            margin-top: 10px;
          }
        }
      }
    }
  }
}
@media screen and (min-width: 1460px) and (max-width: 1540px) {
  .electricity {
    .electricity-bottom {
      .power-threshold {
        .threshold-content {
          margin-top: 16px;
          .box {
            margin-bottom: 10px;
            .content-input {
              width: 48%;
              .el-input {
                width: 30%;
              }
            }
          }
          .save-btn {
            margin-left: 3%;
          }
        }
        .line-line {
          margin-bottom: 10px;
        }
        .soc {
          .save-btn {
            margin-top: 10px;
          }
        }
      }
    }
  }
}
@media screen and (min-width: 1330px) and (max-width: 1460px) {
  .electricity {
    .electricity-bottom {
      .power-threshold {
        .threshold-content {
          margin-top: 10px;
          .box {
            margin-bottom: 6px;
            .content-input {
              width: 48%;
              float: left;
              span {
                top: 4px;
                font-size: 10px;
              }
              .el-input {
                width: 30%;
                font-size: 10px;
              }
            }
          }
          .save-btn {
            margin-left: 3%;
            .el-button {
              padding: 6px 2px;
            }
          }
        }
        .line-line {
          margin-bottom: 10px;
        }
        .soc {
          .save-btn {
            margin-top: 6px;
            .el-button {
              padding: 6px 2px;
            }
          }
        }
      }
    }
  }
}
@media screen and (min-width: 1270px) and (max-width: 1330px) {
  .electricity {
    .electricity-bottom {
      .power-threshold {
        .threshold-content {
          margin-top: 10px;
          .box {
            margin-bottom: 6px;
            .content-input {
              width: 48%;
              span {
                top: 4px;
                font-size: 10px;
                transform: scale(0.7);
              }
              .el-input {
                width: 28%;
                font-size: 8px;
                // transform: scale(0.7);
              }
            }
          }
          .save-btn {
            margin-left: 3%;
            .el-button {
              padding: 6px 2px;
              font-size: 10px;
            }
          }
        }
        .line-line {
          margin-bottom: 10px;
        }
        .soc {
          .content-input {
            .el-select {
              font-size: 10px;
            }
          }
          .save-btn {
            margin-top: 6px;
            .el-button {
              padding: 6px 2px;
              font-size: 10px;
            }
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">
.electricity {
  .electricity-bottom .power-threshold .soc .content-input .el-select {
    ::-webkit-input-placeholder {
      /* WebKit browsers */
      color: #58b6ea !important;
    }
    :-moz-placeholder {
      /* Mozilla Firefox 4 to 18 */
      color: #58b6ea !important;
    }
    ::-moz-placeholder {
      /* Mozilla Firefox 19+ */
      color: #58b6ea !important;
    }
    :-ms-input-placeholder {
      /* Internet Explorer 10+ */
      color: #58b6ea !important;
    }
    .el-input__inner {
      border: 1px solid #60c8ff !important;
      background-color: transparent !important;
      color: #58b6ea !important;
    }
    .el-input {
      .el-select__caret {
        color: #58b6ea !important;
      }
    }
  }
  .top-right,
  .pile-select {
    .el-select {
      ::-webkit-input-placeholder {
        /* WebKit browsers */
        color: #58b6ea !important;
      }
      :-moz-placeholder {
        /* Mozilla Firefox 4 to 18 */
        color: #58b6ea !important;
      }
      ::-moz-placeholder {
        /* Mozilla Firefox 19+ */
        color: #58b6ea !important;
      }
      :-ms-input-placeholder {
        /* Internet Explorer 10+ */
        color: #58b6ea !important;
      }
      .el-input__inner {
        border: 1px solid #60c8ff !important;
        background-color: transparent !important;
        color: #58b6ea !important;
      }
      .el-input {
        .el-select__caret {
          color: #58b6ea !important;
        }
      }
    }
  }
  .electricity-bottom {
    .threshold-content {
      .el-input {
        .el-input__inner {
          background-color: transparent !important;
          border: 1px solid #58b6ea;
          color: #58b6ea !important;
        }
      }
    }
  }
}
.electricity-body .el-select-dropdown {
  border: 1px solid #135a69 !important;
  background-color: #132b39 !important;
  ul {
    li {
      span {
        color: #58b6ea !important;
      }
    }
    li:hover {
      background-color: #317dd6 !important;
      span {
        color: #fff !important;
      }
    }
  }
  .popper__arrow {
    display: none !important;
  }
}
.el-popper {
  margin-top: 0 !important;
}
.electricity-body .el-select-dropdown__item.hover,
.electricity-body .el-select-dropdown__item:hover {
  background-color: #317dd6 !important;
  span {
    color: #fff !important;
  }
}
@media screen and (min-width: 1550px) and (max-width: 1650px) {
  .electricity {
    .electricity-bottom {
      .power-threshold {
        .el-input {
          .el-input__inner {
            height: 30px !important;
          }
        }
        .el-input__icon {
          line-height: 30px;
        }
      }
    }
  }
}
@media screen and (min-width: 1450px) and (max-width: 1550px) {
  .electricity {
    .electricity-bottom {
      .power-threshold {
        .el-input {
          .el-input__inner {
            height: 30px !important;
          }
        }
        .el-input__icon {
          line-height: 30px;
        }
      }
    }
  }
}
@media screen and (min-width: 1350px) and (max-width: 1450px) {
  .electricity {
    .electricity-bottom {
      .power-threshold {
        .el-input {
          .el-input__inner {
            height: 30px !important;
          }
        }
        .el-input__icon {
          line-height: 30px;
        }
      }
    }
  }
}
@media screen and (min-width: 1250px) and (max-width: 1350px) {
  .electricity {
    .electricity-bottom {
      .power-threshold {
        .el-input {
          .el-input__inner {
            height: 25px !important;
          }
        }
        .el-input__icon {
          line-height: 25px;
        }
      }
    }
  }
}
@media screen and (min-width: 1150px) and (max-width: 1250px) {
  .electricity {
    .electricity-bottom {
      .power-threshold {
        .el-input {
          .el-input__inner {
            height: 25px !important;
          }
        }
        .el-input__icon {
          line-height: 25px;
        }
      }
    }
  }
}
@media screen and (max-width: 1150px) {
  .electricity {
    .electricity-bottom {
      .power-threshold {
        .el-input {
          .el-input__inner {
            height: 25px !important;
          }
        }
        .el-input__icon {
          line-height: 25px;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.electricity {
  .el-input__inner {
    height: 32px !important;
  }
  .el-input__icon {
    line-height: 32px;
  }
}
.electricity .electricity-bottom .threshold-content .el-input .el-input__inner {
  padding-right: 0;
}
@media screen and (min-width: 1250px) and (max-width: 1540px) {
  .electricity
    .electricity-bottom
    .threshold-content
    .el-input
    .el-input__inner {
    padding-left: 2px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/realTimeMonitoring/electricityMonitoring.vue